<template lang="pug">
.checkbox(:class="`${selected ? 'selected' : ''} ${text ? '' : 'no-text'} ${clickable ? 'clickable' : ''} ${disabled ? 'disabled' : ''}`")
  .checkbox-square(@click.stop="emit()", tabindex="0", @keyup.enter.stop="emit()", @keyup.space.stop="emit()")
    .checkbox-icon(v-if="icon"): i(:class="`mdi mdi-${icon}`")
  .checkbox-text(v-if="text", v-html="text", @click="clickable ? emit() : linkClick($event)", @keyup.enter.stop="clickable ? emit() : linkClick($event)")
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
    selected: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    /**
     * Emits the choosen one to parent
     * @param {String|Boolean} value
     */
    emit() {
      if (this.disabled) {
        return;
      }

      this.$emit('input', true);
    },
    /**
     * Emit an event if a link was clicked in the text
     * @param {Object} event
     */
    linkClick(event) {
      if (event.target.tagName.toLowerCase() === 'a') {
        this.$emit('linkClick', true);
      }
    },
  },
  data() {
    return {
    };
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.checkbox {
  align-items: center;
  display: flex;
  position: relative;

  &.disabled {
    opacity: .6;
  }

  &.no-event {
    & > * {
      pointer-events: none;
    }
  }

  &:last-child {
    margin-bottom: 0;
  }

  &.selected {
    .checkbox-square {
      background-color: #0360FF;
      border: 2px solid #0360FF;
    }

    .checkbox-text {
      font-weight: 500;
    }

    .checkbox-icon {
      opacity: 1;
    }
  }

  &:hover {
    &:not(.selected) {
      .checkbox-icon {
        color: #B7C7E7;
        opacity: 1;
      }
    }
  }

  &.clickable {
    .checkbox-text {
      &:hover {
        cursor: pointer;
      }
    }
  }

  &.no-text {
    .checkbox-square, .checkbox-icon {
      margin-right: 0;
    }
  }

  .checkbox-square {
    transition: background-color .3s, border-color .3s;
    align-items: center;
    border: 1px solid #D7D9E0;
    // border-radius: 4px;
    display: inline-flex;
    min-height: 20px;
    height: 20px;
    margin-right: .8rem;
    justify-content: center;
    position: relative;
    min-width: 20px;
    width: 20px;

    &:hover {
      cursor: pointer;
    }
  }

  .checkbox-icon {
    transition: opacity .3s;
    color: white;
    font-size: 18px;
    font-weight: 100;
    margin-right: 4px;
    position: absolute;
    pointer-events: none;
    opacity: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  .checkbox-text {
    font-weight: 400;
    line-height: 1.2;
    word-break: break-word;
    font-size: .9rem;

    span {
      color: #8591A0;
      font-size: .9rem;
      display: block;
    }

    a {
      color: #0360FF;
    }
  }

  &.site-style {
    &:not(.selected) {
      .checkbox-square {
        border: 2px solid #B7C7E7;
      }
    }

    .checkbox-text {
      color: #909090;

      a {
        color: #0360FF;
      }
    }
  }

  &.large {
    height: 40px;
    width: 40px;
    .checkbox-square {
      height: 40px;
      width: 40px;
      margin: 0;
    }

    .checkbox-icon{
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>

<style lang="scss">
.checkbox {
  .checkbox-text {
    a {
      color: #0360FF;
    }
  }
}
</style>
